export default {
      id: "small-loading-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#small-loading",
      toString: function () {
        return this.url;
      }
    }